import { BaseModel } from '../../../models/base-model'
import { Task } from '../task'
import { TaskCompletionStatus } from './task-completion-status'
import { TaskFlaggedStatus } from './task-flagged-status'

export class UserTask extends BaseModel {
  private static FLAG_STATES = Object.keys(TaskFlaggedStatus).map((v) => parseInt(v, 10)).filter((v) => !isNaN(v))
  private static DEFAULT_FLAG: TaskFlaggedStatus = TaskFlaggedStatus.Flag1

  public completionStatus: string // TaskCompletionStatus
  public flagged: TaskFlaggedStatus
  public task: Task
  public userId: string
  public updatedAt: Date

  public get isFinished(): boolean {
    return this.completionStatus === TaskCompletionStatus[TaskCompletionStatus.Complete] ||
    this.completionStatus === TaskCompletionStatus[TaskCompletionStatus.Skip]
  }

  public get isIncomplete(): boolean {
    return this.completionStatus === TaskCompletionStatus[TaskCompletionStatus.Incomplete]
  }

  public constructor() {
    super()
    this.completionStatus = TaskCompletionStatus[TaskCompletionStatus.Incomplete]
    this.flagged = UserTask.DEFAULT_FLAG
  }

  public setNextFlag() {
    const currentIndex = UserTask.FLAG_STATES.indexOf(this.flagged)
    const nextIndex = (currentIndex !== -1) ? ( (currentIndex + 1 ) % UserTask.FLAG_STATES.length ) : 0

    this.flagged = UserTask.FLAG_STATES[nextIndex]
    return this.flagged
  }

  public setCompletionStatus(status: string) {
    this.completionStatus = TaskCompletionStatus[TaskCompletionStatus[status]]
  }

  public setFlaggedStatus(status: string) {
    this.flagged = TaskFlaggedStatus[status]
  }

  public isFlagged() {
    return typeof this.flagged !== 'undefined' && this.flagged !== UserTask.DEFAULT_FLAG
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/user-task/user-task.ts